/**
 * 用户
 */
import request from '../utils/request'
/* eslint-disable */

/**
 * 校验验证码
 * @param params
 * @returns {AxiosPromise}
 */
export function checkValidate (params) {
    return request({
        url: 'user/checkValidate',
        method: 'get',
        params: params
    })
}

/**
 * 校验用户名称
 * @param params
 * @returns {AxiosPromise}
 */
export function nameValidate (params) {
    return request({
        url: 'user/nameValidate',
        method: 'get',
        params: params
    })
}

/**
 * 注册用户
 * @param params
 * @returns {AxiosPromise}
 */
export function register (params) {
    return request({
        url: 'user/register',
        method: 'post',
        params: params
    })
}

/**
 * 登录验证
 * @param params
 * @returns {AxiosPromise}
 */
export function loginAes (params) {
    return request({
        url: 'user/login/loginAes',
        method: 'post',
        params: params
    })
}

/**
 * 修改密码
 * @param params
 * @returns {AxiosPromise}
 */
export function updatePass (params) {
    return request({
        url: 'user/config/updatePass',
        method: 'post',
        params: params
    })
}

/**
 * 保存用户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function updateUser (params) {
    return request({
        url: 'user/config/updateUser',
        method: 'post',
        params: params
    })
}

/**
 * 保存代理信息
 * @param params
 * @returns {AxiosPromise}
 */
export function updateAgent (params) {
    return request({
        url: 'user/config/updateAgent',
        method: 'post',
        params: params
    })
}

/**
 * 得到代理信息
 * @param params
 * @returns {AxiosPromise}
 */
export function agentInfo (params) {
    return request({
        url: 'user/config/agentInfo',
        method: 'get',
        params: params
    })
}

/**
 * 得到用户信息
 * @param params
 * @returns {AxiosPromise}
 */
export function userInfo (params) {
    return request({
        url: 'user/config/userInfo',
        method: 'get',
        params: params
    })
}

/**
 * 提交材料
 * @param params
 * @returns {AxiosPromise}
 */
export function saveMaterials (params) {
    return request({
        url: 'user/config/saveMaterials',
        method: 'post',
        data: params
    })
}

/**
 * 加载身份图片信息
 * @param params
 * @returns {AxiosPromise}
 */
export function userCerti (params) {
    return request({
        url: 'user/config/userCerti',
        method: 'get',
        params: params
    })
}

